import type {RouteRecordRaw} from 'vue-router';

export const invoiceRoutes: RouteRecordRaw[] = [
  {
    name: 'invoices',
    path: '/invoices',
    component: () => import('@/views/Financial/Invoices/InvoicesIndex.vue'),
    meta: {
      permissions: ['selectInvoice', 'getProformaInvoice'],
      title: (t) => t('finance.invoice.title', 2),
    },
  },
  {
    name: 'invoice-upcoming',
    path: '/invoices/upcoming',
    component: () => import('@/views/Financial/UpcomingInvoices/UpcomingInvoiceIndex.vue'),
    meta: {
      permissions: ['selectInvoiceItem'],
      title: (t) => t('finance.invoice.upcoming.title', 2),
    },
  },
  {
    name: 'credit-debit',
    path: '/credit-debit',
    component: () => import('@/views/Financial/ExceptionalPayments/ExceptionalPaymentsIndex.vue'),
    meta: {
      permissions: ['selectInvoiceItem'],
      title: (t) => t('finance.exceptionalPayments.title'),
    },
  },
];
